<template>
  <div>
    <div class="row" v-if="false">
        <sp-card/>
        <sp-card/>
        <sp-card/>
        <sp-card/>
    </div>
    <sp-360-panel :title="tabela.titulo" :tooltipOptions="tabela.topTooltipOptions">
        <sp360-chart :data="filaSaudeChart" type="vertical-bar" :options="filaSaudeChartOptions"/>
        <div class="flex-box">
            <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP" :habilitarAnimacaoClique="false"></sp-map>
            <sp360-data-table id="tabelaFilaSaude" ref="filaSaude"
                :apiMode="false"
                :data="tabela.tableData.data"
                :fields="tabela.tableFields"
                :sortFunctions="tabela.sortFunctions"
                :perPage="tabela.itemsPerPage"
            />
        </div>
    </sp-360-panel>
  </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpCard from '@/components/dashboard/SP360Card'
import AutoUpdate from '@/services/AutoUpdate'
import SpMap from '@/components/maps/360-maps/SPMap'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Multiselect from 'vue-multiselect'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'

export default {
  name: 'demanda-regionalizada',
  mixins: [],
  components: { SpMap, Multiselect, SpCard, Sp360Chart, Sp360DataTable },

  data () {
    return {
      cores: _.shuffle(CorUtils.getVetorCoresPorTom('claro').concat(CorUtils.getVetorCoresPorTom('medio'))),
      dados: [],
      set: [],
      tooltip: { placement: 'bottom', content: 'empty' },
      tabela: {
        titulo: 'Fila De Exame Por Tipo Procedimento Por Regiao',
        tableData: { 'data': [] },
        tableFields: [
          {
            name: 'subprefeitura',
            sortField: 'subprefeitura',
            title: 'Subprefeitura',
            width: '20%',
          },
          {
            name: 'total',
            sortField: 'total',
            title: 'Total',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'procedimentos_clinicos',
            sortField: 'procedimentos_clinicos',
            title: 'Procedimentos clínicos',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'procedimentos_com_finalidade_diagnostica',
            sortField: 'procedimentos_com_finalidade_diagnostica',
            title: 'Procedimentos com finalidade diagnóstica',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'orteses_proteses_e_materiais_especiais',
            sortField: 'orteses_proteses_e_materiais_especiais',
            title: 'Órteses, próteses e materiais especiais',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'procedimentos_cirurgicos',
            sortField: 'procedimentos_cirurgicos',
            title: 'Procedimentos cirúrgicos',
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
        ],
        sortFunctions: {
          'subprefeitura': MethGlob.ordenaTabela,
          'total': MethGlob.ordenaTabelaParseInt,
          'procedimentos_clinicos': MethGlob.ordenaTabelaParseInt,
          'procedimentos_com_finalidade_diagnostica': MethGlob.ordenaTabelaParseInt,
          'orteses_proteses_e_materiais_especiais': MethGlob.ordenaTabelaParseInt,
          'procedimentos_cirurgicos': MethGlob.ordenaTabelaParseInt,
        },
        topTooltipOptions: {
          content: this.$t('graficosEducacao.filaDaCrecheNotaTecnica') + '</br>' + this.$t('graficosEducacao.filaDaCrecheNotaTecnica2'), placement: 'bottom', classes: 'va-tooltip customTooltip',
        },
        itemsPerPage: 6, // Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SERVICO_POR_REGIAO,
      },
      filaSaudeChartOptions: {},
      filaSaudeChart: { labels: [], datasets: [] },
      filaSaudeChartB: { labels: [], datasets: [] },
      coresTabela: [CorUtils.getCorPorNomeSp360(CorUtils.VERMELHO_MEDIO),
        CorUtils.getCorPorNomeSp360(CorUtils.AMARELO_MEDIO),
        CorUtils.getCorPorNomeSp360(CorUtils.VERDE_MEDIO),
        CorUtils.getCorPorNomeSp360(CorUtils.AZUL_GLAUCO_ESCURO)],
    }
  },

  created () {
    Promise.all([
      this.$store.dispatch('saude/buscarFilaDeExamePorTipoProcedimentoPorRegiao', { tipoProcedimento: 'TODOS' }),
      this.$store.dispatch('saude/buscarEstoqueDeRemediosPorUnidade'),
      this.$store.dispatch('saude/buscarEstoqueDeRemedios'),
    ]).then(respostas => {
      this.$set(this.tabela.tableData, 'data', this.popularTabela(respostas[0].data.data))

      this.pintarRegiao(respostas[1].data.data)

      // this.$refs.filaSaude.update();

      this.criarLegenda()

      this.filaSaudeChart = this.fillDataSet({ labels: [], datasets: [] }, _.orderBy(this.set, 'total', 'desc'), 'total',
        'subprefeitura', 'Total de Procedimentos', this.cores)

      this.filaSaudeChart = this.fillDataSetB(this.filaSaudeChart,
        respostas[1].data.data, 'perc_estoque', 'id_sub', '% de estoque', this.cores)

      this.filaSaudeChartOptions = this.getchartOptions('Subprefeitura', 'Numero de Procedimentos nas Filas')
    })
  },

  methods: {
    filtrarPorRegiao (id) {
      let idNum = MethGlob.idSvgToNumeric(id)
      if (this.ultimoClickNomeSub != id) {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
      } else {
        this.$refs.mapa.limparClick(id)
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
        this.munAtual = this.$t('graficosEducacao.geral')
      }
    },

    popularTabela (dados) {
      dados.forEach(e => {
        let datatable = {
          id_subprefeitura: 0,
          subprefeitura: '',
          total: 0,
          procedimentos_clinicos: 0,
          procedimentos_com_finalidade_diagnostica: 0,
          orteses_proteses_e_materiais_especiais: 0,
          procedimentos_cirurgicos: 0,
        }
        datatable.id_subprefeitura = e.id_subprefeitura
        datatable.subprefeitura = e.subprefeitura
        datatable.total = e.total
        e.lista_tipos_procedimentos.forEach(p => {
          if (p.tipo_procedimento === 'Procedimentos clínicos') {
            datatable.procedimentos_clinicos = p.total
          } else if (p.tipo_procedimento === 'Procedimentos com finalidade diagnóstica') {
            datatable.procedimentos_com_finalidade_diagnostica = p.total
          } else if (p.tipo_procedimento === 'Órteses, próteses e materiais especiais') {
            datatable.orteses_proteses_e_materiais_especiais = p.total
          } else if (p.tipo_procedimento === 'Procedimentos cirúrgicos') {
            datatable.procedimentos_cirurgicos = p.total
          }
        })
        this.set.push(datatable)
      })
      return _.orderBy(this.set, 'total', 'desc')
    },

    criarLegenda () {
      this.$refs.mapa.definirLegenda(
        this.coresTabela,
        ['Estoque de Medicamentos',
          'Crítico',
          'Regular',
          'Bom',
          'Ideal',
        ]
      )
    },

    // Pinta as areas do mapa de acorco com um valor arbitrario
    // TODO : Delimitar uma formula para o farol.
    pintarRegiao (dados) {
      let geral = dados.shift()
      let legendaCores = CorUtils.getVetorCoresFarol()

      dados.forEach((element) => {
        let x = (element.total) / geral.total
        let mediaSub = ((geral.total / dados.length) / geral.total)
        let id = 'sub' + element.id_sub
        let rgb = ''
        if (x > (mediaSub * 1.5)) {
          rgb = legendaCores[2]
        } else if (x >= (mediaSub * 1.2)) {
          rgb = legendaCores[2] // vermelho
        } else if (x >= mediaSub * 0.8) {
          rgb = legendaCores[1] // amarelo
        } else {
          rgb = legendaCores[0] // verde
        }
        this.$refs.mapa.pintarRegiao(id, rgb)
      })
    },

    pintarRegiaoRemedios (dados) {
      let universo = dados.length
      let dadosOrdenados = _.groupBy(dados, 'id_sub')
      for (const key in dadosOrdenados) {
        if (dadosOrdenados.hasOwnProperty(key)) {
          const e = dadosOrdenados[key]
          e.total = _.reduce(e, (i, n) => { return i + n.perc_estoque }, 0)
          e.perc_total = (e.total / e.length)
          e.classificacao = this.getClassificadorPerc(e.perc_total)
          e.subprefeitura = SPMapaNomes.find(function (e) {
            if (e.id == key) {
              return e.nome
            }
          })
          e.subprefeitura = e.subprefeitura.nome
          this.$refs.mapa.pintarRegiao('sub' + key, e.classificacao)
        }
      }
      return dadosOrdenados
    },

    // coresTabela: [CorUtils.getCorPorNomeSp360(CorUtils.VERMELHO_MEDIO),
    // CorUtils.getCorPorNomeSp360(CorUtils.AMARELO_MEDIO),
    // CorUtils.getCorPorNomeSp360(CorUtils.VERDE_MEDIO),
    // CorUtils.getCorPorNomeSp360(CorUtils.AZUL_GLAUCO_ESCURO)],
    getClassificadorPerc (perc) {
      if (perc >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.IDEAL) return this.coresTabela[3]
      if (perc >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.BOM) return this.coresTabela[2]
      if (perc >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.REGULAR) return this.coresTabela[1]
      if (perc >= Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.RANGE.CRITICO) return this.coresTabela[0]
    },

    getchartOptions (xAxixLabel, yAxixLabel) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 20,
            bottom: 0,
          },
        },
        plugins: {
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => MethGlob.thousandSeparator(value),
            anchor: 'end',
            align: 'end',
            color: '#000',
            display: 'true',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        },
        tooltips: {
          enabled: true,
        },
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            // categoryPercentage: 0.2,
            // barPercentage: 1.0,

            scaleLabel: {
              display: true,
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
            },
          }],
          yAxes: [{
            type: 'linear',
            display: true,
            position: 'left',
            id: 'A',
            scaleLabel: {
              display: true,
              labelString: yAxixLabel,
            },
            ticks: {
              callback: function (value, index, values) {
                return MethGlob.thousandSeparator(value)
              },
            },
          }, {
            type: 'linear',
            display: true,
            position: 'right',
            id: 'B',
            scaleLabel: {
              display: true,
              labelString: 'Estoque de Medicamentos (%)',
            },
            ticks: {
              callback: function (value, index, values) {
                return MethGlob.thousandSeparator(value)
              },
            },
          }],
        },
      }
    },

    fillDataSet (chartData, dados, atr_data, atr_leg, dataset_label, backgroundColor) {
      dados.shift()
      let palette = this.$store.getters.palette
      let dataset = {}
      dataset.data = []
      dados.forEach(element => {
        chartData.labels.push(element[atr_leg])
        dataset.yAxisID = 'A'
        dataset.data.push(element[atr_data])
        dataset.label = dataset_label
      })
      dataset.backgroundColor = backgroundColor
      dataset.borderColor = palette.transparent
      chartData.datasets.push(dataset)
      return chartData
    },

    fillDataSetB (chartData, dados, atr_data, atr_leg, dataset_label, backgroundColor) {
      let palette = this.$store.getters.palette

      let dataset = {
        yAxisID: 'B',
        label: dataset_label,
        backgroundColor: backgroundColor,
        data: [],
      }

      for (const key in dados) {
        if (dados.hasOwnProperty(key)) {
          const element = dados[key]
          dataset.data.push(element[atr_data].toFixed(2))
        }
      }

      chartData.datasets.push(dataset)
      return chartData
    },

  },
}
</script>

<style lang="scss" scoped>
    .flex-box{
        display: flex;
    }
    #mapaSP{
        width: 25%;
    }
    #tabelaFilaCreche{
        width: 75%;
        height: auto
    }
</style>

<style lang="scss">
